import { render, staticRenderFns } from "./KonvaCampaignSequenceModal.vue?vue&type=template&id=881d4100&scoped=true"
import script from "./KonvaCampaignSequenceModal.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignSequenceModal.vue?vue&type=script&lang=js"
import style0 from "./KonvaCampaignSequenceModal.vue?vue&type=style&index=0&id=881d4100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881d4100",
  null
  
)

export default component.exports